import styled from 'styled-components';
import { uFlexCenter, uFlexColumn } from '../../assets/styles/utility';

export const EmptyPage = styled.div`
  ${uFlexColumn}
  ${uFlexCenter}
  height: 100vh;
  width: 100vw;
`;
